import { MButton } from '@Components/Base';
import { ReactComponent as DeleteIcon } from '@Icons/additional/trash.svg';

interface DeleteCellProps {
  onClick: () => void;
}

const DeleteCell: React.FC<DeleteCellProps> = ({ onClick }) => {
  return (
    <MButton onClick={onClick}>
      <DeleteIcon />
    </MButton>
  );
};

export default DeleteCell;
